
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import OrganisationPageLayout from '../components/OrganisationPageLayout';
import { fetchOrganisationWithId } from '../actions';
import withNavigationOrganisationProps from '../components/withNavigationOrganisationProps';

import { InfoCard, InfoCardItem } from '../../../components/InfoCard';

import {
  absoluteDateFormatter,
} from '../../../components/table/formatters';

import {
  getOrganisation,
} from '../selectors';

function ActivityPage({
  organisationId,
  organisation = {},
  fetchOrganisationWithId,
}) {

  const { t } = useTranslation();
  // get up to date user info
  useEffect(() => {
    if (organisationId && Object.keys(organisation).length === 0) {
      fetchOrganisationWithId({ id: organisationId });
    }
  }, [organisationId, fetchOrganisationWithId]);

  return (
    <OrganisationPageLayout>
      <InfoCard heading={t('screens.organisations.activity.heading')}>
        <InfoCardItem>
          {absoluteDateFormatter(moment(organisation.created_at).local())}
        </InfoCardItem>
      </InfoCard>
    </OrganisationPageLayout>
  );
}

const mapStateToProps = (state, { organisationId }) => {
  return {
    organisation: organisationId && getOrganisation(state, organisationId),
  };
};
const mapDispatchToProps = {
  fetchOrganisationWithId,
};

export default withNavigationOrganisationProps(
  connect(mapStateToProps, mapDispatchToProps)(ActivityPage)
);
